import React from 'react'
import styled from 'styled-components'
//
//
//
const Dashboard = () => {
  return <Wrapper>dashboard content</Wrapper>
}

// styles
const Wrapper = styled.div`
  /*  */
`

export default Dashboard
